import React, { lazy, useCallback, useEffect, useState } from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import { Box, Button, Typography } from '@mui/material'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../../routes/routeName'
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom'
import StepperCustom from '../../../../components/step/Stepper'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../store/store'
import Hashids from 'hashids'
import { ELibraryCategory, LIBRARY_DETAIL_HISTORY_TYPE, LIBRARY_HEAD_STATUS, LIBRARY_HISTORY_STATUS, LIBRARY_LIKE } from '../../enum/elibrary_enum'
import { ELibraryFrontApi, list_download_e_library } from '../../../../api/e-library/e_library_front.api'
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice'
import BookLikeList from './element/BookCard'
import { globalLikeBookmark } from '../element/global_like_func'
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal'
import PaginationCustom from '../../../../components/pagination/PaginationCustomTwo'
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import BooksCart from '../element/BooksCart'
import StatusCustom from '../../../../components/status/statusCustom'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import moment from 'moment'
import DownloadIcon from '@mui/icons-material/Download';
import { saveAs } from 'file-saver'
import { renderDateTimeThai } from '../../../../utils/app.utils'

const BookSlide = lazy(() => import('../element/BooksViewList'));

type Props = {}

const BorrowBooks = (props: Props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const pathname = location.pathname;
    const base_api = useSelector((state: RootState) => state.api.image_api)!;
    const hash_ids = new Hashids(process.env.REACT_APP_SECRET_SALT, 50);

    // HOOKS
    const [step, set_step] = useState<number>(0);
    const [borrow_data, set_borrow_data] = useState<any[]>([]);
    const [borrow_data_ebook, set_borrow_data_ebook] = useState<any[]>([]);
    const [borrow_data_audio_book, set_borrow_data_audio_book] = useState<any[]>([]);
    const [booked_data, set_booked_data] = useState<any[]>([]);
    const [booked_data_e_book, set_booked_data_e_book] = useState<any[]>([]);
    const [booked_data_audio_book, set_booked_data_audio_book] = useState<any[]>([]);

    const [page_like, set_page_like] = useState<number>(1);
    const [page_limit_like, _set_page_limit_like] = useState<number>(10);
    const [total_items_like, set_total_items_like] = useState<number>(0);
    const [data_like, set_data_like] = useState<any[]>([]);

    const [page_bookmark, set_page_bookmark] = useState<number>(1);
    const [page_limit_bookmark, _set_page_limit_bookmark] = useState<number>(10);
    const [total_items_bookmark, set_total_items_bookmark] = useState<number>(0);
    const [data_bookmark, set_data_bookmark] = useState<any[]>([]);

    const [page_history_buy, set_page_history_buy] = useState<number>(1);
    const [page_limit_history_buy, _set_page_limit_history_buy] = useState<number>(10);
    const [total_items_history_buy, set_total_items_history_buy] = useState<number>(0);
    const [data_history_buy, set_data_history_buy] = useState<any[]>([]);

    const [page_history_buy_ebook, set_page_history_buy_ebook] = useState<number>(1);
    const [page_limit_history_buy_ebook, _set_page_limit_history_buy_ebook] = useState<number>(10);
    const [total_items_history_buy_ebook, set_total_items_history_buy_ebook] = useState<number>(0);
    const [data_history_buy_ebook, set_data_history_buy_ebook] = useState<any[]>([]);

    const [page_download_magazine, set_page_download_magazine] = useState<number>(1);
    const [page_limit_download_magazine, set_page_limit_download_magazine] = useState<number>(10);
    const [total_items_download_magazine, set_total_items_download_magazine] = useState<number>(0);
    const [page_download_thesis, set_page_download_thesis] = useState<number>(1);
    const [page_limit_download_thesis, set_page_limit_download_thesis] = useState<number>(10);
    const [magazine_data_download, set_magazine_data_download] = useState<any[]>([]);
    const [total_items_download_thesis, set_total_items_download_thesis] = useState<number>(0);
    const [thesis_data_download, set_thesis_data_download] = useState<any[]>([]);






    // API CALLBACK

    const handleGetBorrowData = async (type: string, library_category_name: string, set_data?: React.Dispatch<React.SetStateAction<any[]>>) => {
        dispatch(setLoading());
        // 1 =  ยืม
        await ELibraryFrontApi.borrowOrBookedList(type, library_category_name, 1).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || [];
                if (set_data) {
                    set_data(response);
                } else {
                    set_borrow_data(response)
                }
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleCancelBooked = (id_library_history: number, library_category_name: string) => {
        alertActive("ยกเลิกการจอง", "ท่านต้องการ ยกเลิกการจองหรือไม่?", undefined, undefined, async () => {
            dispatch(setLoading());
            await ELibraryFrontApi.cancelBooked(id_library_history).then((res) => {
                if (res.status < 300) {
                    alertSuccess("ยกเลิกการจอง", "ยกเลิกการจอง สำเร็จ");
                    if (library_category_name === ELibraryCategory.BOOK) {
                        handleGetBookedData(LIBRARY_DETAIL_HISTORY_TYPE.BOOKED, library_category_name);
                    } else if (library_category_name === ELibraryCategory.E_BOOK) {
                        handleGetBookedData(LIBRARY_DETAIL_HISTORY_TYPE.BOOKED, library_category_name, set_booked_data_e_book);
                    } else if (library_category_name === ELibraryCategory.AUDIO_BOOK) {
                        handleGetBookedData(LIBRARY_DETAIL_HISTORY_TYPE.BOOKED, library_category_name, set_booked_data_audio_book);
                    }
                }
            }).catch((err) => {
                console.log(err);
                alertError("ยกเลิกการจอง ไม่สำเร็จ", err?.response?.data?.message)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const handleGetBookedData = async (type: string, library_category_name: string, set_data?: React.Dispatch<React.SetStateAction<any[]>>) => {
        dispatch(setLoading());
        await ELibraryFrontApi.borrowOrBookedList(type, library_category_name).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || [];
                if (set_data) {
                    set_data(response);
                } else {
                    set_booked_data(response);
                }
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleGetListLike = useCallback(async () => {
        dispatch(setLoading());
        await ELibraryFrontApi.listLikeBookmark({ page: page_like, limit: page_limit_like, type: LIBRARY_LIKE.LIKE }).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_total_items_like(res.data?.data?.meta?.totalItems || 0);
                set_data_like(response)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page_like, page_limit_like, step])

    const handleGetListBookmark = useCallback(async () => {
        dispatch(setLoading());
        await ELibraryFrontApi.listLikeBookmark({ page: page_bookmark, limit: page_limit_bookmark, type: LIBRARY_LIKE.BOOKMARK }).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_total_items_bookmark(res.data?.data?.meta?.totalItems || 0);
                set_data_bookmark(response);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page_bookmark, page_limit_bookmark, step])

    const handleDownloadFile = async (id_library_file: number, file_name: string) => {
        dispatch(setLoading());
        await ELibraryFrontApi.downloadFile(id_library_file).then((res) => {
            if (res.status < 300) {
                const response = res.data;
                const blob_file = new Blob([response], { type: 'application/pdf' });
                saveAs(blob_file, file_name)
            }
        }).catch((err) => {
            alertError("ดาวน์โหลดไฟล์ไม่สำเร็จ")
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleGetListBuyItem = useCallback(async () => {
        dispatch(setLoading());
        await ELibraryFrontApi.historyBuyItem({ page: page_history_buy, limit: page_limit_history_buy, library_category_name: ELibraryCategory.BOOK }).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_total_items_history_buy(res.data?.data?.meta?.totalItems || 0);
                set_data_history_buy(response);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page_history_buy, page_limit_history_buy, step])

    const handleGetListBuyItemEbook = useCallback(async () => {
        dispatch(setLoading());
        await ELibraryFrontApi.historyBuyItem({ page: page_history_buy_ebook, limit: page_limit_history_buy_ebook, library_category_name: ELibraryCategory.E_BOOK }).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_total_items_history_buy_ebook(res.data?.data?.meta?.totalItems || 0);
                set_data_history_buy_ebook(response);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page_history_buy_ebook, page_limit_history_buy, step])

    const handleCancelLikeBookmark = (id_library_head: number, type: LIBRARY_LIKE) => {
        alertActive("ยกเลิก", "ท่านต้องการยกเลิกรายการนี้?", undefined, undefined, async () => {
            if (type === LIBRARY_LIKE.LIKE) {
                await globalLikeBookmark(id_library_head, type);
                await handleGetListLike();
                alertSuccess("ยกเลิก", "ยกเลิกสำเร็จ");
            } else if (type === LIBRARY_LIKE.BOOKMARK) {
                await globalLikeBookmark(id_library_head, type);
                await handleGetListBookmark();
                alertSuccess("ยกเลิก", "ยกเลิกสำเร็จ");
            }
        })
        return false
    }
    const handleReturnBorrow = (id_library_head: number, library_category_name: string, callback?: () => void) => {
        alertActive("คืน", "ท่านต้องการคืนรายการนี้?", undefined, undefined, async () => {
            dispatch(setLoading());
            await ELibraryFrontApi.returnBorrow(id_library_head).then((res) => {
                if (res.status < 300) {
                    alertSuccess("คืน", "คืน รายการนี้เรียบร้อย");
                    // ต้องส่ง setter ให้ตรงกับ category ไม่งั้นข้อมูลจะถูกเขียนลง state ผิดตัว (ค่า default คือลิสต์หนังสือ)
                    if (library_category_name === ELibraryCategory.E_BOOK) {
                        handleGetBorrowData(LIBRARY_DETAIL_HISTORY_TYPE.BORROW, library_category_name, set_borrow_data_ebook);
                    } else if (library_category_name === ELibraryCategory.AUDIO_BOOK) {
                        handleGetBorrowData(LIBRARY_DETAIL_HISTORY_TYPE.BORROW, library_category_name, set_borrow_data_audio_book);
                    } else {
                        handleGetBorrowData(LIBRARY_DETAIL_HISTORY_TYPE.BORROW, library_category_name);
                    }
                    callback?.()
                }
            }).catch((err) => {
                console.log(err)
                alertError("คืน ไม่สำเร็จ", err?.response?.data?.message)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
        return false
    }

    const handleGetListDownloadMagazine = useCallback(async (library_category_name: string, set_data: React.Dispatch<React.SetStateAction<any[]>>) => {
        let query: list_download_e_library = {
            library_category_name,
            limit: page_limit_download_magazine,
            page: page_download_magazine
        }
        await ELibraryFrontApi.listDownload(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                const total = res.data?.data?.meta?.totalItems || 0;
                set_total_items_download_magazine(total)
                set_data(response)
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [page_limit_download_magazine, page_download_magazine, step])
    const handleGetListDownloadThesis = useCallback(async (library_category_name: string, set_data: React.Dispatch<React.SetStateAction<any[]>>) => {
        let query: list_download_e_library = {
            library_category_name,
            limit: page_limit_download_thesis,
            page: page_download_thesis
        }
        await ELibraryFrontApi.listDownload(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                const total = res.data?.data?.meta?.totalItems || 0;
                set_total_items_download_thesis(total)
                set_data(response)
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [page_limit_download_thesis, page_download_thesis, step])

    const handleGetHistoryData = async (library_category_name: string, set_data?: React.Dispatch<React.SetStateAction<any[]>>) => {
        dispatch(setLoading());
        // 1 =  ยืม
        await ELibraryFrontApi.listBorrowReturnHistory(library_category_name).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || [];
                if (set_data) {
                    set_data(response);
                } else {
                    set_borrow_data(response)
                }
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }



    useEffect(() => {
        if (step === 0) {
            handleGetBorrowData(LIBRARY_DETAIL_HISTORY_TYPE.BORROW, ELibraryCategory.BOOK);
            handleGetBorrowData(LIBRARY_DETAIL_HISTORY_TYPE.BORROW, ELibraryCategory.E_BOOK, set_borrow_data_ebook);
            handleGetBorrowData(LIBRARY_DETAIL_HISTORY_TYPE.BORROW, ELibraryCategory.AUDIO_BOOK, set_borrow_data_audio_book);
        }
        else if (step === 1) {
            handleGetBookedData(LIBRARY_DETAIL_HISTORY_TYPE.BOOKED, ELibraryCategory.BOOK);
            handleGetBookedData(LIBRARY_DETAIL_HISTORY_TYPE.BOOKED, ELibraryCategory.E_BOOK, set_booked_data_e_book);
            handleGetBookedData(LIBRARY_DETAIL_HISTORY_TYPE.BOOKED, ELibraryCategory.AUDIO_BOOK, set_booked_data_audio_book);
        } else if (step === 3) {
            handleGetHistoryData(ELibraryCategory.BOOK);
            handleGetHistoryData(ELibraryCategory.E_BOOK, set_borrow_data_ebook);
            handleGetHistoryData(ELibraryCategory.AUDIO_BOOK, set_borrow_data_audio_book);
        }
    }, [step])

    useEffect(() => {
        if (step === 4) {
            handleGetListDownloadMagazine(ELibraryCategory.MAGAZINE, set_magazine_data_download);
        }
    }, [handleGetListDownloadMagazine])
    useEffect(() => {
        if (step === 4) {
            handleGetListDownloadThesis(ELibraryCategory.THESIS, set_thesis_data_download);
        }
    }, [handleGetListDownloadThesis])

    useEffect(() => {
        if (step === 2) {
            handleGetListBuyItem();
        }
    }, [handleGetListBuyItem])

    useEffect(() => {
        if (step === 2) {
            handleGetListBuyItemEbook();
        }
    }, [handleGetListBuyItemEbook])
    useEffect(() => {
        if (step === 5) {
            handleGetListLike()
        }
    }, [handleGetListLike])
    useEffect(() => {
        if (step === 6) {
            handleGetListBookmark()
        }
    }, [handleGetListBookmark])

    return (
        <ContainerLayout
            title='รายการยืม/จอง'
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "จัดการข้อมูล E-Library",
                            name: "จัดการข้อมูล E-Library",
                            pathName: routeName.e_library.books,
                            disabled_match: true
                        },
                        {
                            key: 'A',
                            name: "รายการยืม/จอง",
                            pathName: pathname
                        },
                    ]}
                />
            }
            buttonContent={
                <BooksCart />
            }
            content={
                <Box>
                    <Box sx={{ maxWidth: 'fit-content', margin: "0 auto" }}>
                        <StepperCustom
                            setStep={(st) => set_step(st)}
                            step={step}
                            view
                            maxWidthScroll='600px'
                            sx={{ maxWidth: "816px", margin: '0 auto' }}
                            stepLabel={[
                                {
                                    isAccept: true,
                                    name: "ยืม",
                                    disabled: false
                                },
                                {
                                    isAccept: true,
                                    name: "จอง",
                                    disabled: false
                                },
                                {
                                    isAccept: true,
                                    name: "ซื้อ",
                                    disabled: false
                                },
                                {
                                    isAccept: true,
                                    name: "ประวัติ",
                                    disabled: false
                                },
                                {
                                    isAccept: true,
                                    name: "รายการดาวน์โหลด",
                                    disabled: false
                                },
                                {
                                    isAccept: true,
                                    name: "รายการถูกใจ",
                                    disabled: false
                                },
                                {
                                    isAccept: true,
                                    name: "บุ๊กมาร์ก",
                                    disabled: false
                                },
                            ]}
                        />
                    </Box>


                    <Box>
                        {step === 0 && (
                            <React.Suspense fallback={<div>กำลังโหลด...</div>}>
                                <Box className="flex flex-col gap-5">
                                    <BookSlide
                                        title="หนังสือ"
                                        subtitle=""
                                        hidden_like_bookmark
                                        // onViewAll={() => navigate({ pathname: routeName.e_library.books_list, search: createSearchParams({ status: LIBRARY_HEAD_STATUS.POPULAR }).toString() })}
                                        data={borrow_data?.map((list) => {
                                            const img_url = `${base_api}/${list?.file_path}${list?.file_name}`;
                                            return {
                                                onClick: (id) => {
                                                    const encode_id = hash_ids.encode(String(id || ""));
                                                    navigate({ pathname: routeName.e_library.books_detail.replace(":id", encode_id), search: createSearchParams({ status: LIBRARY_HEAD_STATUS.POPULAR }).toString() })
                                                },
                                                book_name: list?.library_head_name || "",
                                                book_sub_name: list?.library_author_by || "",
                                                id: list?.id_library_head,
                                                img_url: img_url,
                                                otherContent: (
                                                    <Box display={"flex"} flexDirection={"column"} gap={1} my={1.5}>
                                                        <Typography>{list?.remaining_time ?? "-"}</Typography>
                                                        {list?.library_history_status === LIBRARY_HISTORY_STATUS.BORROW ? (
                                                            <Button onClick={(e) => {
                                                                e.stopPropagation();
                                                                list?.id_library_head && handleReturnBorrow(list?.id_library_head, ELibraryCategory.BOOK)
                                                            }} fullWidth variant='contained' color='error'>
                                                                คืน
                                                            </Button>
                                                        ) : (
                                                            <StatusCustom
                                                                // text={LIBRARY_HISTORY_STATUS.WAITING_APPROVE_BORROW}
                                                                // type={LIBRARY_HISTORY_STATUS.WAITING_APPROVE_BORROW}
                                                                text={list?.library_history_status ?? ""}
                                                                type={LIBRARY_HISTORY_STATUS.WAITING_APPROVE_BORROW}
                                                            />
                                                        )}

                                                    </Box>
                                                )
                                            }
                                        })}
                                    />
                                    <BookSlide
                                        title="E-book"
                                        subtitle=""
                                        hidden_like_bookmark
                                        // onViewAll={() => navigate({ pathname: routeName.e_library.books_list, search: createSearchParams({ status: LIBRARY_HEAD_STATUS.POPULAR }).toString() })}
                                        data={borrow_data_ebook?.map((list) => {
                                            const img_url = `${base_api}/${list?.file_path}${list?.file_name}`;
                                            return {
                                                onClick: (id) => {
                                                    const encode_id = hash_ids.encode(String(id || ""));
                                                    navigate({ pathname: routeName.e_library.e_books_detail.replace(":id", encode_id), search: createSearchParams({ status: LIBRARY_HEAD_STATUS.POPULAR }).toString() })
                                                },
                                                book_name: list?.library_head_name || "",
                                                book_sub_name: list?.library_author_by || "",
                                                id: list?.id_library_head,
                                                img_url: img_url,
                                                otherContent: (
                                                    <Box display={"flex"} flexDirection={"column"} gap={1} my={1.5}>
                                                        <Typography>{list?.remaining_time ?? "-"}</Typography>
                                                        {list?.library_history_status === LIBRARY_HISTORY_STATUS.BORROW ? (
                                                            <Button onClick={(e) => {
                                                                e.stopPropagation();
                                                                list?.id_library_head && handleReturnBorrow(list?.id_library_head, ELibraryCategory.E_BOOK)
                                                            }} fullWidth variant='contained' color='error'>คืน</Button>
                                                        ) : (
                                                            <StatusCustom
                                                                text={list?.library_history_status || LIBRARY_HISTORY_STATUS.WAITING_APPROVE_BORROW}
                                                                type={list?.library_history_status || LIBRARY_HISTORY_STATUS.WAITING_APPROVE_BORROW}
                                                            />
                                                        )}
                                                    </Box>
                                                )
                                            }
                                        })}
                                    />
                                    <BookSlide
                                        title="หนังสือเสียง"
                                        subtitle=""
                                        hidden_like_bookmark
                                        // onViewAll={() => navigate({ pathname: routeName.e_library.audio_book_list, search: createSearchParams({ status: LIBRARY_HEAD_STATUS.POPULAR }).toString() })}
                                        data={borrow_data_audio_book?.map((list) => {
                                            const img_url = `${base_api}/${list?.file_path}${list?.file_name}`;
                                            return {
                                                onClick: (id) => {
                                                    const encode_id = hash_ids.encode(String(id || ""));
                                                    navigate({ pathname: routeName.e_library.audio_book_detail.replace(":id", encode_id), search: createSearchParams({ status: LIBRARY_HEAD_STATUS.POPULAR }).toString() })
                                                },
                                                book_name: list?.library_head_name || "",
                                                book_sub_name: list?.library_author_by || "",
                                                id: list?.id_library_head,
                                                img_url: img_url,
                                                otherContent: (
                                                    <Box display={"flex"} flexDirection={"column"} gap={1} my={1.5}>
                                                        <Typography>{list?.remaining_time ?? "-"}</Typography>
                                                        {list?.library_history_status === LIBRARY_HISTORY_STATUS.BORROW ? (
                                                            <Button onClick={(e) => {
                                                                e.stopPropagation();
                                                                list?.id_library_head && handleReturnBorrow(list?.id_library_head, ELibraryCategory.AUDIO_BOOK)
                                                            }} fullWidth variant='contained' color='error'>คืน</Button>
                                                        ) : (
                                                            <StatusCustom
                                                                text={LIBRARY_HISTORY_STATUS.WAITING_APPROVE_BORROW}
                                                                type={LIBRARY_HISTORY_STATUS.WAITING_APPROVE_BORROW}
                                                            />
                                                        )}
                                                    </Box>
                                                )
                                            }
                                        })}
                                    />
                                </Box>
                            </React.Suspense>
                        )}
                        {step === 1 && (
                            <React.Suspense fallback={<div>กำลังโหลด...</div>}>
                                <Box className="flex flex-col gap-6">
                                    <BookSlide
                                        title="หนังสือ"
                                        subtitle=""
                                        hidden_like_bookmark
                                        // onViewAll={() => navigate({ pathname: routeName.e_library.books_list, search: createSearchParams({ status: LIBRARY_HEAD_STATUS.POPULAR }).toString() })}
                                        data={booked_data?.map((list) => {
                                            const img_url = `${base_api}/${list?.file_path}${list?.file_name}`;
                                            return {
                                                onClick: (id) => {
                                                    const encode_id = hash_ids.encode(String(id || ""));
                                                    navigate({ pathname: routeName.e_library.books_detail.replace(":id", encode_id), search: createSearchParams({ status: LIBRARY_HEAD_STATUS.POPULAR }).toString() })
                                                },
                                                book_name: list?.library_head_name || "",
                                                book_sub_name: list?.library_author_by || "",
                                                id: list?.id_library_head,
                                                img_url: img_url,
                                                otherContent: (
                                                    <Box display={"flex"} width={"fit-content"} flexDirection={"column"} gap={1} my={1.5}>
                                                        <Box className="flex justify-start items-center gap-2">
                                                            <Typography>ประมาณ</Typography>
                                                            <Typography color={"red"}>{list?.remaining_next_due_time ?? "-"}</Typography>
                                                        </Box>
                                                        <Button startIcon={<CancelPresentationIcon />} onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleCancelBooked(list?.id_library_history, ELibraryCategory.BOOK);
                                                        }} fullWidth variant='contained' color='error'>ยกเลิกจอง</Button>
                                                    </Box>
                                                )
                                            }
                                        })}
                                        breakpoints={{
                                            320: { slidesPerView: 2, spaceBetween: 12 },
                                            360: { slidesPerView: 2.2, spaceBetween: 12 },
                                            480: { slidesPerView: 2.6, spaceBetween: 14 },
                                            640: { slidesPerView: 3.2, spaceBetween: 16 },
                                            768: { slidesPerView: 4, spaceBetween: 16 },
                                            1024: { slidesPerView: 5, spaceBetween: 16 },
                                            1280: { slidesPerView: 5, spaceBetween: 16 },
                                            1536: { slidesPerView: 5, spaceBetween: 16 },
                                            1720: { slidesPerView: 5, spaceBetween: 16 },
                                            1920: { slidesPerView: 5, spaceBetween: 16 },
                                        }}
                                    />
                                    <BookSlide
                                        title="E-book"
                                        subtitle=""
                                        hidden_like_bookmark
                                        // onViewAll={() => navigate({ pathname: routeName.e_library.books_list, search: createSearchParams({ status: LIBRARY_HEAD_STATUS.POPULAR }).toString() })}
                                        data={booked_data_e_book?.map((list) => {
                                            const img_url = `${base_api}/${list?.file_path}${list?.file_name}`;
                                            return {
                                                onClick: (id) => {
                                                    const encode_id = hash_ids.encode(String(id || ""));
                                                    navigate({ pathname: routeName.e_library.books_detail.replace(":id", encode_id), search: createSearchParams({ status: LIBRARY_HEAD_STATUS.POPULAR }).toString() })
                                                },
                                                book_name: list?.library_head_name || "",
                                                book_sub_name: list?.library_author_by || "",
                                                id: list?.id_library_head,
                                                img_url: img_url,
                                                otherContent: (
                                                    <Box display={"flex"} width={"fit-content"} flexDirection={"column"} gap={1} my={1.5}>
                                                        <Box className="flex justify-start items-center gap-2">
                                                            <Typography>ประมาณ</Typography>
                                                            <Typography color={"red"}>{list?.remaining_next_due_time ?? "-"}</Typography>
                                                        </Box>
                                                        <Button startIcon={<CancelPresentationIcon />} onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleCancelBooked(list?.id_library_history, ELibraryCategory.E_BOOK);
                                                        }} fullWidth variant='contained' color='error'>ยกเลิกจอง</Button>
                                                    </Box>
                                                )
                                            }
                                        })}
                                        breakpoints={{
                                            320: { slidesPerView: 2, spaceBetween: 12 },
                                            360: { slidesPerView: 2.2, spaceBetween: 12 },
                                            480: { slidesPerView: 2.6, spaceBetween: 14 },
                                            640: { slidesPerView: 3.2, spaceBetween: 16 },
                                            768: { slidesPerView: 4, spaceBetween: 16 },
                                            1024: { slidesPerView: 5, spaceBetween: 16 },
                                            1280: { slidesPerView: 5, spaceBetween: 16 },
                                            1536: { slidesPerView: 5, spaceBetween: 16 },
                                            1720: { slidesPerView: 5, spaceBetween: 16 },
                                            1920: { slidesPerView: 5, spaceBetween: 16 },
                                        }}
                                    />
                                    <BookSlide
                                        title="หนังสือเสียง"
                                        subtitle=""
                                        hidden_like_bookmark
                                        // onViewAll={() => navigate({ pathname: routeName.e_library.audio_book_list, search: createSearchParams({ status: LIBRARY_HEAD_STATUS.POPULAR }).toString() })}
                                        data={booked_data_audio_book?.map((list) => {
                                            const img_url = `${base_api}/${list?.file_path}${list?.file_name}`;
                                            return {
                                                onClick: (id) => {
                                                    const encode_id = hash_ids.encode(String(id || ""));
                                                    navigate({ pathname: routeName.e_library.audio_book_detail.replace(":id", encode_id), search: createSearchParams({ status: LIBRARY_HEAD_STATUS.POPULAR }).toString() })
                                                },
                                                book_name: list?.library_head_name || "",
                                                book_sub_name: list?.library_author_by || "",
                                                id: list?.id_library_head,
                                                img_url: img_url,
                                                otherContent: (
                                                    <Box display={"flex"} width={"fit-content"} flexDirection={"column"} gap={1} my={1.5}>
                                                        <Box className="flex justify-start items-center gap-2">
                                                            <Typography>ประมาณ</Typography>
                                                            <Typography color={"red"}>{list?.remaining_next_due_time ?? "-"}</Typography>
                                                        </Box>
                                                        <Button startIcon={<CancelPresentationIcon />} onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleCancelBooked(list?.id_library_history, ELibraryCategory.AUDIO_BOOK);
                                                        }} fullWidth variant='contained' color='error'>ยกเลิกจอง</Button>
                                                    </Box>
                                                )
                                            }
                                        })}
                                        breakpoints={{
                                            320: { slidesPerView: 2, spaceBetween: 12 },
                                            360: { slidesPerView: 2.2, spaceBetween: 12 },
                                            480: { slidesPerView: 2.6, spaceBetween: 14 },
                                            640: { slidesPerView: 3.2, spaceBetween: 16 },
                                            768: { slidesPerView: 4, spaceBetween: 16 },
                                            1024: { slidesPerView: 5, spaceBetween: 16 },
                                            1280: { slidesPerView: 5, spaceBetween: 16 },
                                            1536: { slidesPerView: 5, spaceBetween: 16 },
                                            1720: { slidesPerView: 5, spaceBetween: 16 },
                                            1920: { slidesPerView: 5, spaceBetween: 16 },
                                        }}
                                    />
                                </Box>
                            </React.Suspense>
                        )}

                        {step === 2 && (
                            <>
                                <BookLikeList
                                    baseApi={base_api}
                                    onCancel={({ id }) => { }}
                                    hidden_button={true}
                                    dataLike={data_history_buy?.map((list) => {
                                        const file_url = list?.file_path_example ? `${base_api}/${list?.file_path_example}${list?.file_name_example}` : ""
                                        return {
                                            file_name: list?.file_name,
                                            file_path: list?.file_path,
                                            id: list?.id_library_head,
                                            library_author_by: list?.library_author_by,
                                            library_head_name: list?.library_head_name,
                                            other_content: () => (
                                                <Box>
                                                    <Button
                                                        disabled={!file_url}
                                                        onClick={() => window.open(file_url, "_blank")}
                                                        startIcon={<VisibilityOutlinedIcon />}
                                                        sx={{ borderRadius: "8px" }}
                                                        variant='outlined'>
                                                        อ่านตัวอย่าง
                                                    </Button>
                                                </Box>
                                            )
                                        }
                                    })}
                                />
                                <PaginationCustom
                                    page={page_history_buy}
                                    pageLimit={page_limit_history_buy}
                                    setPage={(np) => set_page_history_buy(np)}
                                    totalItems={total_items_history_buy}
                                    next_button_text='ถัดไป'
                                    prev_button_text='ก่อนหน้า'
                                />

                                <Box my={2}></Box>
                                {data_history_buy_ebook?.length > 0 && (
                                    <>
                                        <BookLikeList
                                            title='E-book'
                                            baseApi={base_api}
                                            onCancel={({ id }) => { }}
                                            hidden_button={true}
                                            dataLike={data_history_buy_ebook?.map((list) => {
                                                const file_url = list?.file_path_data ? `${base_api}/${list?.file_path_data}${list?.file_name_data}` : ""
                                                return {
                                                    file_name: list?.file_name,
                                                    file_path: list?.file_path,
                                                    id: list?.id_library_head,
                                                    library_author_by: list?.library_author_by,
                                                    library_head_name: list?.library_head_name,
                                                    other_content: () => (
                                                        <Box>
                                                            <Button
                                                                disabled={!file_url}
                                                                onClick={() => window.open(file_url, "_blank")}
                                                                startIcon={<VisibilityOutlinedIcon />}
                                                                sx={{ borderRadius: "8px" }}
                                                                variant='outlined'>
                                                                อ่าน
                                                            </Button>
                                                        </Box>
                                                    )
                                                }
                                            })}
                                        />
                                        <PaginationCustom
                                            page={page_history_buy_ebook}
                                            pageLimit={page_limit_history_buy_ebook}
                                            setPage={(np) => set_page_history_buy_ebook(np)}
                                            totalItems={total_items_history_buy_ebook}
                                            next_button_text='ถัดไป'
                                            prev_button_text='ก่อนหน้า'
                                        />
                                    </>
                                )}

                            </>
                        )}

                        {step === 3 && (
                            <Box className="flex flex-col gap-6">
                                {borrow_data?.length > 0 && (
                                    <BookLikeList
                                        baseApi={base_api}
                                        onCancel={({ id }) => id && handleCancelLikeBookmark(+id, LIBRARY_LIKE.LIKE)}
                                        hidden_button
                                        dataLike={borrow_data?.map((list) => {
                                            const is_borrow = (list?.library_history_status === LIBRARY_HISTORY_STATUS.BORROW)
                                            return {
                                                file_name: list?.file_name,
                                                file_path: list?.file_path,
                                                id: list?.id_library_head,
                                                library_author_by: list?.library_author_by,
                                                library_head_name: list?.library_head_name,
                                                other_text_content: (
                                                    <>
                                                        <Box sx={{ py: .5 }}>
                                                            <Typography sx={{ fontSize: "14px" }}>วันที่ยืม</Typography>
                                                            <Typography sx={{ fontSize: "14px" }}>{renderDateTimeThai(list?.library_history_date)}</Typography>
                                                        </Box>
                                                        {list?.library_history_return_date && (
                                                            <Box sx={{ py: .5 }}>
                                                                <Typography sx={{ fontSize: "14px" }}>วันที่คืน</Typography>
                                                                <Typography sx={{ fontSize: "14px" }}>{renderDateTimeThai(list?.library_history_return_date)}</Typography>
                                                            </Box>
                                                        )}
                                                    </>
                                                ),
                                                other_content: () => (
                                                    <Box>
                                                        {is_borrow && (
                                                            <Button onClick={() => {
                                                                list?.id_library_head && handleReturnBorrow(list?.id_library_head, ELibraryCategory.BOOK, () => {
                                                                    handleGetBorrowData(LIBRARY_DETAIL_HISTORY_TYPE.BORROW, ELibraryCategory.BOOK);
                                                                })
                                                            }} variant='contained' color='error'>คืน</Button>
                                                        )}
                                                    </Box>
                                                )
                                            }
                                        })}
                                    />
                                )}
                                {borrow_data_ebook?.length > 0 && (
                                    <BookLikeList
                                        title='E-book'
                                        baseApi={base_api}
                                        onCancel={({ id }) => id && handleCancelLikeBookmark(+id, LIBRARY_LIKE.LIKE)}
                                        hidden_button
                                        dataLike={borrow_data_ebook?.map((list) => {
                                            const is_borrow = (list?.library_history_status === LIBRARY_HISTORY_STATUS.BORROW)
                                            return {
                                                file_name: list?.file_name,
                                                file_path: list?.file_path,
                                                id: list?.id_library_head,
                                                library_author_by: list?.library_author_by,
                                                library_head_name: list?.library_head_name,
                                                other_text_content: (
                                                    <>
                                                        <Box sx={{ py: .5 }}>
                                                            <Typography sx={{ fontSize: "14px" }}>วันที่ยืม</Typography>
                                                            <Typography sx={{ fontSize: "14px" }}>{renderDateTimeThai(list?.library_history_date)}</Typography>
                                                        </Box>
                                                        {list?.library_history_return_date && (
                                                            <Box sx={{ py: .5 }}>
                                                                <Typography sx={{ fontSize: "14px" }}>วันที่คืน</Typography>
                                                                <Typography sx={{ fontSize: "14px" }}>{renderDateTimeThai(list?.library_history_return_date)}</Typography>
                                                            </Box>
                                                        )}
                                                    </>
                                                ),
                                                other_content: () => (
                                                    <Box>
                                                        {is_borrow && (
                                                            <Button onClick={() => {
                                                                list?.id_library_head && handleReturnBorrow(list?.id_library_head, ELibraryCategory.E_BOOK, () => {
                                                                    handleGetBorrowData(LIBRARY_DETAIL_HISTORY_TYPE.BORROW, ELibraryCategory.E_BOOK, set_borrow_data_ebook);
                                                                })
                                                            }} variant='contained' color='error'>คืน</Button>
                                                        )}
                                                    </Box>
                                                )
                                            }
                                        })}
                                    />
                                )}
                                {borrow_data_audio_book?.length > 0 && (
                                    <BookLikeList
                                        title='หนังสือเสียง'
                                        baseApi={base_api}
                                        onCancel={({ id }) => id && handleCancelLikeBookmark(+id, LIBRARY_LIKE.LIKE)}
                                        hidden_button
                                        dataLike={borrow_data_audio_book?.map((list) => {
                                            const is_borrow = (list?.library_history_status === LIBRARY_HISTORY_STATUS.BORROW)
                                            return {
                                                file_name: list?.file_name,
                                                file_path: list?.file_path,
                                                id: list?.id_library_head,
                                                library_author_by: list?.library_author_by,
                                                library_head_name: list?.library_head_name,
                                                other_text_content: (
                                                    <>
                                                        <Box sx={{ py: .5 }}>
                                                            <Typography sx={{ fontSize: "14px" }}>วันที่ยืม</Typography>
                                                            <Typography sx={{ fontSize: "14px" }}>{renderDateTimeThai(list?.library_history_date)}</Typography>
                                                        </Box>
                                                        {list?.library_history_return_date && (
                                                            <Box sx={{ py: .5 }}>
                                                                <Typography sx={{ fontSize: "14px" }}>วันที่คืน</Typography>
                                                                <Typography sx={{ fontSize: "14px" }}>{renderDateTimeThai(list?.library_history_return_date)}</Typography>
                                                            </Box>
                                                        )}
                                                    </>
                                                ),
                                                other_content: () => (
                                                    <Box>
                                                        {is_borrow && (
                                                            <Button onClick={() => {
                                                                list?.id_library_head && handleReturnBorrow(list?.id_library_head, ELibraryCategory.AUDIO_BOOK, () => {
                                                                    handleGetBorrowData(LIBRARY_DETAIL_HISTORY_TYPE.BORROW, ELibraryCategory.AUDIO_BOOK, set_borrow_data_audio_book);
                                                                })
                                                            }} variant='contained' color='error'>คืน</Button>
                                                        )}
                                                    </Box>
                                                )
                                            }
                                        })}
                                    />
                                )}
                            </Box>
                        )}
                        {step === 4 && (
                            <>
                                <Box className="flex flex-col gap-4">
                                    <BookLikeList
                                        baseApi={base_api}
                                        title='วารสาร'
                                        onCancel={({ id }) => id && handleCancelLikeBookmark(+id, LIBRARY_LIKE.LIKE)}
                                        hidden_button
                                        dataLike={magazine_data_download?.map((list) => {
                                            return {
                                                file_name: list?.file_name,
                                                file_path: list?.file_path,
                                                id: list?.id_library_head,
                                                library_author_by: list?.library_author_by,
                                                library_head_name: list?.library_head_name,
                                                other_content: () => (
                                                    <Box>
                                                        <Button
                                                            variant='contained'
                                                            color='success'
                                                            onClick={() => list?.id_library_file_download && handleDownloadFile(list?.id_library_file_download, list?.file_name_download)} startIcon={<DownloadIcon />} >
                                                            ดาวน์โหลด
                                                        </Button>
                                                    </Box>
                                                )
                                            }
                                        })}
                                    />
                                    {magazine_data_download?.length > 0 ? (
                                        <PaginationCustom
                                            page={page_download_magazine}
                                            pageLimit={page_limit_download_magazine}
                                            setPage={(np) => set_page_download_magazine(np)}
                                            totalItems={total_items_download_magazine}
                                        />) : <Typography>ไม่พบข้อมูล</Typography>}
                                </Box>
                                <Box className="flex flex-col gap-4">
                                    <BookLikeList
                                        title='วิทยานิพนธ์'
                                        baseApi={base_api}
                                        onCancel={({ id }) => id && handleCancelLikeBookmark(+id, LIBRARY_LIKE.LIKE)}
                                        hidden_button
                                        dataLike={thesis_data_download?.map((list) => {
                                            return {
                                                file_name: list?.file_name,
                                                file_path: list?.file_path,
                                                id: list?.id_library_head,
                                                library_author_by: list?.library_author_by,
                                                library_head_name: list?.library_head_name,
                                                other_content: () => (
                                                    <Box>
                                                        <Button
                                                            variant='contained'
                                                            color='success'
                                                            onClick={() => list?.id_library_file_download && handleDownloadFile(list?.id_library_file_download, list?.file_name_download)} startIcon={<DownloadIcon />} >
                                                            ดาวน์โหลด
                                                        </Button>
                                                    </Box>
                                                )
                                            }
                                        })}
                                    />
                                    {thesis_data_download?.length > 0 ? (
                                        <PaginationCustom
                                            page={page_download_thesis}
                                            pageLimit={page_limit_download_thesis}
                                            setPage={(np) => set_page_download_thesis(np)}
                                            totalItems={total_items_download_thesis}
                                        />
                                    ) : <Typography>ไม่พบข้อมูล</Typography>}
                                </Box>
                            </>
                        )}

                        {step === 5 && data_like?.length > 0 ? (
                            <>
                                <BookLikeList
                                    baseApi={base_api}
                                    onCancel={({ id }) => id && handleCancelLikeBookmark(+id, LIBRARY_LIKE.LIKE)}
                                    dataLike={data_like?.map((list) => {
                                        return {
                                            file_name: list?.file_name,
                                            file_path: list?.file_path,
                                            id: list?.id_library_head,
                                            library_author_by: list?.library_author_by,
                                            library_head_name: list?.library_head_name
                                        }
                                    })}
                                />
                                <PaginationCustom
                                    page={page_like}
                                    pageLimit={page_limit_like}
                                    setPage={(np) => set_page_like(np)}
                                    totalItems={total_items_like}
                                    next_button_text='ถัดไป'
                                    prev_button_text='ก่อนหน้า'
                                />
                            </>
                        ) : null}
                        {step === 6 && data_bookmark?.length > 0 ? (
                            <>
                                <BookLikeList
                                    baseApi={base_api}
                                    onCancel={({ id }) => id && handleCancelLikeBookmark(+id, LIBRARY_LIKE.BOOKMARK)}
                                    dataLike={data_bookmark?.map((list) => {
                                        return {
                                            file_name: list?.file_name,
                                            file_path: list?.file_path,
                                            id: list?.id_library_head,
                                            library_author_by: list?.library_author_by,
                                            library_head_name: list?.library_head_name
                                        }
                                    })}
                                />
                                <PaginationCustom
                                    page={page_bookmark}
                                    pageLimit={page_limit_bookmark}
                                    setPage={(np) => set_page_bookmark(np)}
                                    totalItems={total_items_bookmark}
                                    next_button_text='ถัดไป'
                                    prev_button_text='ก่อนหน้า'
                                />
                            </>
                        ) : null}
                    </Box>
                </Box>
            }
        />
    )
}

export default BorrowBooks